module.exports = __webpack_public_path__ + "static/media/SR101-W2L1-P10M3 Copy.16448717.png";